import styled from 'styled-components'

export const MainStyled = styled.main`
  padding-bottom: ${({ theme }) => theme.mainBottomPadding};
`
